exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-distanceText-___DistanceText__distanceText___654ip {\n  align-self: center;\n  white-space: nowrap;\n  overflow: hidden;\n  font-family: 'Noto Sans';\n}", ""]);

// exports
exports.locals = {
	"distanceText": "src-components-distanceText-___DistanceText__distanceText___654ip"
};